import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { getField, registerField } from 'core/forms';

import FormFieldSelect from 'uikit/forms/components/formFieldSelect';
import { Typo } from 'uikit/content';

import styles from '../styles/formFieldBulkEdit.module.scss';

const FormFieldBulkEdit = ({ fieldId, schema = {}, updateField = () => {}, value = null }) => {
  const { condition: selectValue, value: fieldValue } = value || { condition: 'keep' };
  const isConditionClear = selectValue === 'clear';
  const { fieldType } = schema;

  const handleSelectChange = (newValue) => {
    if (newValue !== selectValue) {
      updateField({ condition: newValue, ...(newValue === 'clear' && { value: null }) });
    }
  };

  const handleFieldChange = (newValue) => {
    updateField({ ...value, value: newValue });
  };

  const FieldComponent = getField(fieldType);

  if (!FieldComponent) return null;

  const selectProps = { menuPosition: 'fixed' };

  return (
    <div className={styles.rowWrap}>
      <div className={styles.selectWrap}>
        <FormFieldSelect
          fieldId={fieldId}
          schema={{
            options: [
              { label: i18n.t('keep-as-is'), value: 'keep' },
              { label: i18n.t('update'), value: 'update' },
              schema.isClearable && { label: i18n.t('clear'), value: 'clear' },
            ].filter(Boolean),
            selectProps,
          }}
          updateField={handleSelectChange}
          value={selectValue}
        />
      </div>
      <div className={styles.fieldWrap}>
        <div className={classnames(styles.field, isConditionClear && styles.isHidden)}>
          <FieldComponent
            fieldId={`${fieldId}-${fieldType}`}
            schema={{
              ...schema,
              isDisabled: selectValue !== 'update',
              selectProps: { ...schema.selectProps, ...selectProps },
            }}
            updateField={handleFieldChange}
            value={fieldValue}
          />
        </div>
        {isConditionClear && (
          <Typo className={styles.clearedMessage} variant="s02">
            {i18n.t('bulk-edit-cleared-message')}
          </Typo>
        )}
      </div>
    </div>
  );
};

FormFieldBulkEdit.propTypes = {
  fieldId: PropTypes.string.isRequired,
  schema: PropTypes.shape({
    fieldType: PropTypes.string,
    isClearable: PropTypes.bool,
  }),
  updateField: PropTypes.func,
  value: PropTypes.shape({
    condition: PropTypes.oneOf(['clear', 'keep', 'update']),
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
  }),
};

registerField('BulkEdit', React.memo(FormFieldBulkEdit));

export default FormFieldBulkEdit;
